import { render, staticRenderFns } from "./InquiryListStatusTag.vue?vue&type=template&id=1cd1e430&"
import script from "./InquiryListStatusTag.vue?vue&type=script&lang=ts&"
export * from "./InquiryListStatusTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports